import { Injectable } from '@angular/core';
import { MyHttpClient } from '../http-client';
import { HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { environment } from '../../environments/environment';

import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { HttpHeaders } from '@angular/common/http';


const cookies = document.cookie.split(';');

const userCookie = cookies.find(function (item) {
  return item.includes('_id');
});

const httpOptions = {
  headers: new HttpHeaders({
    'user': userCookie
  })
};




@Injectable()
export class OnboardingPageService {
  server: string = environment.SERVER;

  riderDetailsJSON = '../src/stubs/riderDetails.json';
  vehiclesListJSON = '../src/stubs/vehiclesList.json';
  citiesListJSON = '../src/stubs/cities.json';

  getRiderURL = process.env.SERVER + '/api/show';
  getCitiesURL = process.env.SERVER + '/api/get/cities';
  assignTLURL = process.env.SERVER + '/api/assign/tl';
  speedTestURL = process.env.SERVER + '/api/speedTest';
  verifyDocsURL = process.env.SERVER + '/api/docs';
  rcDefaulterUrl = process.env.SERVER + '/api/rcDefaulter';
  getCabDataUrl = process.env.SERVER + '/api/cab'

  captainUrl = process.env.SERVER + '/api/captain';
  fleetUrl = process.env.SERVER + '/api/fleet';
  constructor(private http: MyHttpClient) {
}


  getRiderDetails(id) {
    return this.http.get(
        this.getRiderURL + '/' + id).pipe(catchError(this.handleError));
  }

  getFleetVehicleDetails(fleetId, number) {
    return this.http.get(
        this.fleetUrl + '/' + fleetId + '/' + number).pipe(catchError(this.handleError));
  }

  fetchRcDefaulter(riderId) {
    return this.http.get(`${this.rcDefaulterUrl}/${riderId}`).pipe(catchError(this.handleError));
  }

  getCabData(userId, number){
    if(number){
      return this.http.get(this.getCabDataUrl + `/${userId}?number=${number}`).pipe(catchError(this.handleError));
    }
    return this.http.get(this.getCabDataUrl + `/${userId}`).pipe(catchError(this.handleError));
  }

  getCitiesList() {
    return this.http.get(this.getCitiesURL).pipe(catchError(this.handleError));
  }

  getModes(userId) {
    return this.http.get(`${this.captainUrl}/modes/${userId}`).pipe(catchError(this.handleError));
  }

  createFleet(mobile: string) {
    const payload = {
      source: 'supply-dashboard',
      mobile
    };
    return this.http.post(process.env.SERVER + '/api/fleet/fleet', payload).pipe(catchError(this.handleError));
  }

  // New: fetch fleet by mobile via our proxy GET /api/fleet
  getFleetByMobile(mobile: string) {
    const source = 'supply-dashboard';
    return this.http.get(`${this.fleetUrl}?source=${source}&mobile=${mobile}`).pipe(catchError(this.handleError));
  }

  // New: fetch documents (PAN/Aadhar/RC/DL) for a given userId
  getDocuments(userId: string) {
    return this.http.get(`${this.verifyDocsURL}/documents/${userId}`).pipe(catchError(this.handleError));
  }

  // Fleet Manager - BFF proxied APIs
  getUserByMobileViaBff(mobile: string) {
    return this.http.get(`${process.env.SERVER}/api/fleetManager/userByMobile/${mobile}`).pipe(catchError(this.handleError));
  }

  updateUserRolesViaBff(userId: string, roles: string[]) {
    return this.http.put(`${process.env.SERVER}/api/fleetManager/user/${userId}`, { roles }).pipe(catchError(this.handleError));
  }

  createUserViaBff(body: { name: string; city: string; mobile: string }) {
    return this.http.post(`${process.env.SERVER}/api/fleetManager/user`, body).pipe(catchError(this.handleError));
  }

  // Fleets listing via captain-onboard BFF
  getFleetsByType(type: string, userId: string) {
    return this.http.get(`${this.fleetUrl}/details/${type}/${userId}`).pipe(catchError(this.handleError));
  }

  // Fleet Manager creation (API4) via BFF
  createFleetManager(body: {
    source: string;
    mobile: string;
    cityId: string;
    userId: string;
    mobileVerified: boolean;
    fleetId: string;
    name: string;
    status: string;
  }) {
    return this.http.post(`${process.env.SERVER}/api/fleetManager`, body).pipe(catchError(this.handleError));
  }

  // Fleet Manager profile photo upload via BFF (expects base64 data URL)
  uploadFleetManagerProfile(dataUrl: string, userId: string) {
    return this.http.put(`${process.env.SERVER}/api/fleetManager/upload/profilePic`, { data: dataUrl, userId }).pipe(catchError(this.handleError));
  }

  // Fleet Manager fetch by mobile (via BFF GET with a JSON body)
  fetchFleetManagerByMobile(userId: string, mobile: string) {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const params = { source: 'fleet-manager', userId, mobile };

   return this.http.get(`${process.env.SERVER}/api/fleetManager`, {
    headers,
    params
  }).pipe(catchError(this.handleError));
  }

  // Fetch presigned static file URL for onboarding documents
  getStaticFileUrl(imageBucket: string, type: string, name: string, qos?: string) {
    const qosQuery = qos ? `?qos=${encodeURIComponent(qos)}` : '';
    return this.http.get(`${process.env.SERVER}/static/file/v1/${imageBucket}/${type}/${encodeURIComponent(name)}${qosQuery}`)
      .pipe(catchError(this.handleError));
  }

  updateFleet(fleetId: string, body: any) {
    // call our backend which proxies to captain-service with proper headers
    return this.http.put(`${this.fleetUrl}/${fleetId}`, body).pipe(catchError(this.handleError));
  }

    activateFleet(fleetId: string) {
    return this.http.put(`${this.fleetUrl}/activate/${fleetId}`, { source: 'supply-dashboard' }).pipe(catchError(this.handleError));
  }

  getTLList() {
    return this.http.get(`${this.captainUrl}/tlList`).pipe(catchError(this.handleError));

  }
  bulkRejectDocs(documents, userId, fleetId, fleetNumber) {
    const payload = { documents, userId,fleetId, fleetNumber };
    return this.http.post(`${this.captainUrl}/bulkRejectDocs`, payload).pipe(catchError(this.handleError));
  }
  removeService(userId, serviceDetailIds, city) {
    const payload = { userId, serviceDetailId: serviceDetailIds, city };
    return this.http.post(`${this.captainUrl}/removeService`, payload).pipe(catchError(this.handleError));
  }
  doSpeedTest() {
    return this.http.get(this.speedTestURL);
  }
  assignTL(userId, tl, shiftName) {
    const payload = { userId, tl, shift: { 'name': shiftName, 'from': null, 'to': null }};
    return this.http.post(`${this.captainUrl}/assign/tl`, payload)
              .pipe(catchError(this.handleError));
  }

  verifyProfileDLDocs(profileDlInfo) {

    const requestBody = {
      'drivingLicense': profileDlInfo['drivingLicense'],
      'birthDate': profileDlInfo['birthDate'],
      'dlFrontImage' : profileDlInfo['dlImage'],
      'dlBackImage' : profileDlInfo['dlBackImage'],
      'profileImage': profileDlInfo['profileImage'],
      'userId' : profileDlInfo['userId'],
      'actorId': profileDlInfo['actorId'],
      'actorType': profileDlInfo['actorType'],
      'triggeredFrom': profileDlInfo['triggeredFrom'],
      'name': profileDlInfo['name']
    };

    return this.http.post(this.verifyDocsURL + '/validateProfileDlDocuments', requestBody)
                    .pipe(catchError(this.handleError));
  }

  verifyRcDoc(rcInfo) {

    const requestBody = {
      'registrationNumber': rcInfo['registrationNumber'],
      'userId' : rcInfo['userId'],
      'actorId': rcInfo['actorId'],
      'actorType': rcInfo['actorType'],
      'isImageOptional': rcInfo['isImageOptional'],
    };

    return this.http.post(this.verifyDocsURL + '/validateRcDocument', requestBody)
                    .pipe(catchError(this.handleError));
  }

  verifyRoadTaxDoc(roadTaxInfo) {
    const requestBody = {
      'registrationNumber': roadTaxInfo['registrationNumber'],
      'userId': roadTaxInfo['userId'],
      'actorId': roadTaxInfo['actorId'],
      'actorType': roadTaxInfo['actorType'],
      'isImageOptional': roadTaxInfo['isImageOptional'],
    };

    return this.http.post(this.verifyDocsURL + '/validateRoadTaxDocument', requestBody)
                    .pipe(catchError(this.handleError));
  }

  getDocVerificationStatus (userId, docType) {
    return this.http.get(this.verifyDocsURL + `/docVerificationStatus/${userId}/${docType}`).pipe(catchError(this.handleError));
  }

  getTypeConfig(cityId: string, modeName: string) {
    const params = { cityId, modeName };
    return this.http.get(`${process.env.SERVER}/api/config/typeConfig`, { params }).pipe(
      catchError(this.handleError)
    ).toPromise();
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      // A client-side or network error occurred. Handle it accordingly.
      console.error('An error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.error(
        `Backend returned code ${error.status}, ` +
        `body was: ${error.error}`);
    }
    if (error && error.error && error.error.data && error.error.data.data) {
      return throwError(error.error.data.data);
    }

    if (error && typeof error === 'string') {
      return throwError(error);
    }
    // return an observable with a user-facing error message
    return throwError(
      'Something bad happened; please try again later.');
  }

  makeIntentionalError() {
    return this.http.get('not/a/real/url')
      .pipe(
        catchError(this.handleError)
      );
  }

}
